(function () {
  if (window.haChromeBooted) return;
  window.haChromeBooted = true;

  (function () {
  var header = document.getElementById("site-header");
  if (!header) return;

  var ticking = false;
  var measuredHeight = 0;
  var resizeFrame = 0;
  var observesHeader = !!window.ResizeObserver;

  function setHeaderHeight(height) {
    height = Math.round(height);
    if (!height || height === measuredHeight) return;
    measuredHeight = height;
    document.documentElement.style.setProperty("--header-height", height + "px");
  }

  function scheduleHeaderMeasure() {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(function () {
      resizeFrame = 0;
      setHeaderHeight(header.offsetHeight);
    });
  }

  // ResizeObserver provides a completed layout measurement. Scroll updates must
  // not synchronously read geometry after changing the compact-header class.
  if (observesHeader) new ResizeObserver(function (entries) {
    var box = entries[0].borderBoxSize;
    setHeaderHeight(box ? (box[0] || box).blockSize : header.offsetHeight);
  }).observe(header);
  else window.addEventListener("resize", scheduleHeaderMeasure);
  setHeaderHeight(header.offsetHeight);

  function update() {
    header.classList.toggle("is-compact", window.scrollY > 48);
    if (!observesHeader) scheduleHeaderMeasure();
    ticking = false;
  }

  window.addEventListener("scroll", function () {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }, { passive: true });

  update();
  })();

  (function () {
  var header = document.getElementById("site-header");
  if (!header) return;

  var main = header.querySelector(".site-header__main");
  var nav = header.querySelector(".main-nav");
  if (!main || !nav || main.querySelector(".nav-toggle")) return;

  var btn = document.createElement("button");
  btn.className = "nav-toggle";
  btn.type = "button";
  btn.setAttribute("aria-expanded", "false");
  btn.setAttribute("aria-label", "Menu");
  btn.innerHTML = "<span></span><span></span><span></span>";
  main.appendChild(btn);

  var search = header.querySelector(".ha-header-predictive, .search");
  var icons = header.querySelector(".header-icons");
  var mobile = window.matchMedia("(max-width: 820px)");

  function setBackgroundInert(on) {
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el.contains(header)) return;
      if (on) el.setAttribute("inert", "");
      else el.removeAttribute("inert");
    });
  }

  function collapsePanels() {
    Array.prototype.forEach.call(header.querySelectorAll(".main-nav__item--has-panel"), function (item) {
      var link = item.querySelector(".main-nav__link");
      var toggle = item.querySelector(".main-nav__panel-toggle");
      item.classList.remove("is-open");
      item.removeAttribute("data-click-open");
      if (link) {
        if (item.dataset.sbvDirectLink === "true") link.removeAttribute("aria-expanded");
        else link.setAttribute("aria-expanded", "false");
      }
      if (toggle) toggle.setAttribute("aria-expanded", "false");
      var panel = item.querySelector(":scope > .main-nav__panel");
      if (panel) {
        panel.inert = true;
        panel.setAttribute("aria-hidden", "true");
        panel.dispatchEvent(new Event("ha:menu-close"));
      }
    });
  }

  function close() {
    header.classList.remove("nav-open");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-label", "Menu");
    setBackgroundInert(false);
    document.documentElement.classList.remove("ha-nav-lock");
    collapsePanels();
    nav.scrollTop = 0;
  }

  function place() {
    if (mobile.matches) {
      if (search && search.parentNode !== nav) nav.insertBefore(search, nav.firstChild);
    } else {
      if (search && icons && search.parentNode === nav) main.insertBefore(search, icons);
      close();
    }
  }

  btn.addEventListener("click", function () {
    var open = header.classList.toggle("nav-open");
    btn.setAttribute("aria-expanded", open ? "true" : "false");
    btn.setAttribute("aria-label", open ? "Close menu" : "Menu");
    setBackgroundInert(open);
    document.documentElement.classList.toggle("ha-nav-lock", open);
    if (open) {
      collapsePanels();
      nav.scrollTop = 0;
      var first = nav.querySelector("a, input, button, select");
      if (first) first.focus({ preventScroll: true });
    }
  });

  document.addEventListener("keydown", function (event) {
    if (event.defaultPrevented) return;
    if (event.key === "Escape" && header.classList.contains("nav-open")) {
      close();
      btn.focus({ preventScroll: true });
    }
  });

  nav.addEventListener("click", function (event) {
    var anchor = event.target.closest("a");
    if (anchor && !(anchor.classList.contains("main-nav__link") && anchor.getAttribute("aria-haspopup") === "true")) close();
  });

  if (mobile.addEventListener) mobile.addEventListener("change", place);
  else if (mobile.addListener) mobile.addListener(place);

  place();
  })();

  (function () {
  var header = document.getElementById("site-header");
  if (!header) return;

  var items = Array.prototype.slice.call(header.querySelectorAll(".main-nav__item--has-panel"));
  var mobilePanels = window.matchMedia("(max-width: 820px)");
  if (!items.length) return;
  // Hover and retained keyboard focus must not independently reveal two panels.
  header.dataset.menuStateManaged = "true";
  var restoringMenuFocus = false;

  function syncSuppressedVehiclePanel(item) {
    var panel = item.querySelector(":scope > .main-nav__panel");
    var link = item.querySelector(".main-nav__link");
    var toggle = item.querySelector(".main-nav__panel-toggle");
    if (!panel) return false;
    if (panel.dataset.sbvSuppressedDuplicate === "true") {
      if (item.dataset.sbvDirectLink === "true") return true;
      item.dataset.sbvDirectLink = "true";
      item.classList.remove("is-open");
      item.removeAttribute("data-click-open");
      panel.inert = true;
      panel.setAttribute("aria-hidden", "true");
      if (toggle) {
        toggle.hidden = true;
        toggle.style.setProperty("display", "none", "important");
        toggle.setAttribute("aria-expanded", "false");
      }
      if (link) {
        link.removeAttribute("aria-haspopup");
        link.removeAttribute("aria-controls");
        link.removeAttribute("aria-expanded");
      }
      return true;
    }
    if (item.dataset.sbvDirectLink === "true") {
      delete item.dataset.sbvDirectLink;
      if (toggle) {
        toggle.hidden = false;
        toggle.style.removeProperty("display");
      }
      if (link) {
        link.setAttribute("aria-haspopup", "true");
        link.setAttribute("aria-controls", panel.id);
        link.setAttribute("aria-expanded", "false");
      }
    }
    return false;
  }

  // The vehicle component owns duplicate suppression. Only watch that one
  // header attribute so a late primary picker cannot leave a dead chevron.
  items.forEach(syncSuppressedVehiclePanel);
  if (window.MutationObserver) new MutationObserver(function (records) {
    records.forEach(function (record) {
      var item = record.target.closest(".main-nav__item--has-panel");
      if (item) syncSuppressedVehiclePanel(item);
    });
  }).observe(header, { subtree: true, attributes: true, attributeFilter: ["data-sbv-suppressed-duplicate"] });

  function positionPanel(item) {
    if (mobilePanels.matches) return;

    var nav = item.closest(".main-nav");
    var panel = item.querySelector(":scope > .main-nav__panel");
    if (!nav || !panel) return;

    var navRect = nav.getBoundingClientRect();
    var itemRect = item.getBoundingClientRect();
    var panelWidth = panel.offsetWidth;
    var viewportMargin = 24;
    var navCenter = navRect.left + (navRect.width / 2);
    var itemCenter = itemRect.left + (itemRect.width / 2);
    var desiredLeft = itemCenter - (panelWidth / 2);
    var minimumLeft = viewportMargin;
    var maximumLeft = Math.max(minimumLeft, window.innerWidth - viewportMargin - panelWidth);
    var clampedLeft = Math.min(Math.max(desiredLeft, minimumLeft), maximumLeft);
    var baseLeft = navCenter - (panelWidth / 2);

    panel.style.setProperty("--ha-panel-shift-x", Math.round(clampedLeft - baseLeft) + "px");
  }

  function setOpen(item, open) {
    if (syncSuppressedVehiclePanel(item)) return;
    var link = item.querySelector(".main-nav__link");
    var toggle = item.querySelector(".main-nav__panel-toggle");
    var panel = item.querySelector(":scope > .main-nav__panel");
    var wasOpen = item.classList.contains("is-open");
    if (open && panel) panel.dispatchEvent(new CustomEvent("ha:menu-before-open", { bubbles: true }));
    if (open) positionPanel(item);
    item.classList.toggle("is-open", open);
    if (panel) {
      panel.inert = !open;
      panel.setAttribute("aria-hidden", open ? "false" : "true");
      if (wasOpen && !open) panel.dispatchEvent(new Event("ha:menu-close"));
    }
    if (link) link.setAttribute("aria-expanded", open ? "true" : "false");
    if (toggle) toggle.setAttribute("aria-expanded", open ? "true" : "false");
    if (!open) item.removeAttribute("data-click-open");
  }

  function closePanels(except) {
    items.forEach(function (item) {
      if (item !== except) setOpen(item, false);
    });
  }

  items.forEach(function (item) {
    var link = item.querySelector(".main-nav__link");
    var toggle = item.querySelector(".main-nav__panel-toggle");
    if (!link) return;
    /* Review 2026-07-13: every top-level click navigates; panels open on
       hover and focus. The old allowlist left Merch, Blogs and Contact
       swallowing clicks. */
    var linkNavigates = true;

    item.addEventListener("mouseenter", function () {
      if (mobilePanels.matches) return;
      closePanels(item);
      setOpen(item, true);
    });

    item.addEventListener("mouseleave", function () {
      if (mobilePanels.matches) return;
      setOpen(item, false);
    });

    item.addEventListener("focusin", function () {
      if (mobilePanels.matches || restoringMenuFocus) return;
      closePanels(item);
      setOpen(item, true);
    });

    item.addEventListener("focusout", function (event) {
      if (mobilePanels.matches) return;
      if (!item.contains(event.relatedTarget)) setOpen(item, false);
    });

    link.addEventListener("click", function (event) {
      if (linkNavigates) {
        closePanels();
        return;
      }
      event.preventDefault();
      var willOpen = item.getAttribute("data-click-open") !== "true";
      closePanels(item);
      setOpen(item, willOpen);
      if (willOpen) item.setAttribute("data-click-open", "true");
    });

    if (toggle) {
      toggle.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var willOpen = !item.classList.contains("is-open");
        closePanels(item);
        setOpen(item, willOpen);
        if (willOpen) {
          item.setAttribute("data-click-open", "true");
          requestAnimationFrame(function () {
            toggle.scrollIntoView({ block: "nearest" });
          });
        }
      });
    }
  });

  closePanels();

  document.addEventListener("click", function (event) {
    if (!header.contains(event.target)) closePanels();
  });

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      var item = document.activeElement.closest(".main-nav__item--has-panel");
      closePanels();
      if (item) {
        restoringMenuFocus = true;
        item.querySelector(".main-nav__link").focus();
        restoringMenuFocus = false;
      }
    }
  });

  window.addEventListener("resize", function () {
    if (mobilePanels.matches) return;
    items.filter(function (item) { return item.classList.contains("is-open"); }).forEach(positionPanel);
  });
  })();

  (function () {
  /* HVR-063, operator ruling 2026-07-13: the quick rail is THE section
     navigation on every page; only the entries change per page. Product pages
     and blog articles now build the same rail. */
  var productRoot = document.querySelector(".ha-product");
  var articleContent = document.querySelector("[data-article-content]");
  var utilityPage = document.querySelector(".main-blog-hub, .template-search, .contact-page-intro");
  var utilityMain = document.body.classList.contains("ha-utility") || utilityPage ? document.querySelector("main") : null;
  var root = document.querySelector(".ha-supplier") || document.querySelector(".ha-collection") || productRoot || articleContent || utilityMain;

  if (root) {
    root.classList.add("ha-quick-rail-root");
    document.body.classList.add("ha-quick-rail-root");
  }

  if (root && !document.querySelector(".quick-rail")) {
    var icons = {
      grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><rect x="3" y="3" width="7.5" height="7.5" rx="1.5"/><rect x="13.5" y="3" width="7.5" height="7.5" rx="1.5"/><rect x="3" y="13.5" width="7.5" height="7.5" rx="1.5"/><rect x="13.5" y="13.5" width="7.5" height="7.5" rx="1.5"/></svg>',
      truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M1 9h11v7H1zM12 11h5l3 3v2h-8"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="16.5" cy="17.5" r="1.8"/></svg>',
      tag: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.6 13.4 12 22l-9-9V4h9l8.6 8.6z"/><circle cx="7.5" cy="8.5" r="1.4"/></svg>',
      star: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3.5l2.7 5.5 6.1.9-4.4 4.3 1 6L12 17.3l-5.4 2.9 1-6-4.4-4.3 6.1-.9z"/></svg>',
      shield: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l7 3v5.2c0 4.4-2.9 7.4-7 8.8-4.1-1.4-7-4.4-7-8.8V6z"/><path d="M9 11.6l2 2 4-4.2"/></svg>',
      book: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 6c-1.6-1.4-3.8-2-6-2H4v14h2c2.2 0 4.4.6 6 2 1.6-1.4 3.8-2 6-2h2V4h-2c-2.2 0-4.4.6-6 2z"/><path d="M12 6v14"/></svg>',
      wrench: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M14.7 6.3a4 4 0 0 0-5.4 5.4L3 18l3 3 6.3-6.3a4 4 0 0 0 5.4-5.4l-2.8 2.8-2.4-2.4 2.2-3.4z"/></svg>',
      flame: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 21c3.9 0 6.5-2.5 6.5-6 0-2.6-1.6-4.6-3-6.2-.6 1-1.3 1.7-2.2 2.2 0-2.6-1.1-5.4-3.3-7-.2 2.2-1 3.7-2.3 5.1C6.4 10.6 5.5 12.4 5.5 15c0 3.5 2.6 6 6.5 6z"/></svg>',
      gauge: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4.5 18a9 9 0 1 1 15 0"/><path d="M12 14l4-5"/><circle cx="12" cy="15" r="1.6"/></svg>',
      thumb: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 11v9H4a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h3zM7 11l4.2-7.5a2 2 0 0 1 2.7 2L13 10h6a2 2 0 0 1 2 2.4l-1.3 6A2 2 0 0 1 17.7 20H7"/></svg>',
      chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a8 8 0 0 1-8 8H4l2.2-2.6A8 8 0 1 1 21 12z"/><path d="M8.5 10.5h7M8.5 13.5h4.5"/></svg>',
      layers: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3l9 4.8-9 4.8-9-4.8z"/><path d="M3 12.4l9 4.8 9-4.8"/><path d="M3 16.6l9 4.8 9-4.8"/></svg>'
    };

    var bestsellers = document.querySelector(".bestsellers");
    if (bestsellers && !bestsellers.id) bestsellers.id = "picks";

    var picksLabel = "Recommended products";
    var picksElement = document.getElementById("picks");
    if (picksElement && picksElement.classList.contains("collection-products-section")) picksLabel = "All products";

    var slugify = function (value) {
      return value.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/(^-|-$)/g, "").slice(0, 60);
    };

    /* Round nine 2026-07-14: every rail entry carries its own icon */
    var candidates = [
      { id: "departments", label: "Shop by department", icon: icons.grid },
      { id: "ranges", label: "Shop the range", icon: icons.layers },
      { id: "shop-by-category", label: "Shop by category", icon: icons.grid },
      { id: "makes", label: "Shop by make", icon: icons.layers },
      { id: "fitment", label: "Search by Vehicle", icon: icons.truck },
      { id: "brands", label: "Search by Brand", icon: icons.tag },
      { id: "picks", label: picksLabel, icon: icons.star },
      { id: "fitment-help", label: "Fitment help", icon: icons.chat },
      { id: "why", label: "Why Hoonies", icon: icons.shield },
      { id: "garage", label: "Latest guides", icon: icons.book },
      { id: "demo-builds", label: "Demo builds", icon: icons.flame },
      { id: "recommended-products", label: "Recommended", icon: icons.thumb },
      { id: "tuning-parts", label: "Support the tune", icon: icons.wrench },
      { id: "proof", label: "The Hoonies part", icon: icons.gauge }
    ];

    var candidateById = candidates.reduce(function (map, candidate) {
      map[candidate.id] = candidate;
      return map;
    }, {});

    var iconForSection = function (id, label, index) {
      if (candidateById[id]) return candidateById[id].icon;
      var token = (id + " " + label).toLowerCase();
      if (token.indexOf("fit") !== -1 || token.indexOf("vehicle") !== -1) return icons.truck;
      if (token.indexOf("faq") !== -1 || token.indexOf("why") !== -1) return icons.shield;
      if (token.indexOf("product") !== -1 || token.indexOf("pick") !== -1 || token.indexOf("best") !== -1) return icons.star;
      if (token.indexOf("demo") !== -1 || token.indexOf("build") !== -1) return icons.flame;
      if (token.indexOf("guide") !== -1 || token.indexOf("article") !== -1 || token.indexOf("blog") !== -1) return icons.book;
      if (token.indexOf("proof") !== -1 || token.indexOf("workshop") !== -1) return icons.gauge;
      if (token.indexOf("range") !== -1 || token.indexOf("categor") !== -1) return icons.layers;
      return [icons.grid, icons.tag, icons.wrench, icons.book][index % 4];
    };

    var buildDynamicSectionItems = function () {
      var main = document.querySelector("main") || document;
      var seen = {};
      var sectionNodes = Array.prototype.slice.call(main.querySelectorAll("section, [data-ha-rail-section]"));

      candidates.forEach(function (candidate) {
        var element = document.getElementById(candidate.id);
        if (element && sectionNodes.indexOf(element) === -1) sectionNodes.push(element);
      });

      // Read every visibility/heading value before assigning IDs or styles.
      // The previous mixed loop forced a new layout for each following section.
      var visibleItems = sectionNodes.reduce(function (result, section, index) {
        if (!section.offsetParent || section.closest("footer, .shopify-section-group-footer-group")) return result;

        var heading = section.querySelector("h2, h1");
        if (heading && heading.closest("section") && heading.closest("section") !== section) heading = null;

        var known = section.id ? candidateById[section.id] : null;
        var label = heading ? heading.textContent.trim().replace(/\s+/g, " ") : (known ? known.label : "");
        if (!label) return result;

        var id = section.id || "section-" + (slugify(label) || String(index));
        if (seen[id]) return result;
        seen[id] = true;
        result.push({
          element: section,
          id: id,
          label: label.slice(0, 54),
          icon: iconForSection(id, label, result.length)
        });
        return result;
      }, []);
      visibleItems.forEach(function (item) {
        if (!item.element.id) item.element.id = item.id;
        if (item.element.style.scrollMarginTop !== "calc(var(--header-height, 0px) + 24px)") {
          item.element.style.scrollMarginTop = "calc(var(--header-height, 0px) + 24px)";
        }
      });
      return visibleItems.slice(0, 10);
    };

    var items;
    if (productRoot) {
      var pdpDetailsLabel = document.querySelector("#details .spec-card, .buybox .spec-card") ? "Specs" : "Details";
      items = [
        { id: "buy", label: "Overview", icon: icons.grid },
        { id: "details", label: pdpDetailsLabel, icon: icons.book },
        { id: "fitment", label: "Fitment", icon: icons.truck },
        { id: "picks", label: "Pairs well", icon: icons.star },
        { id: "faq", label: "FAQ", icon: icons.shield }
      ].filter(function (item) {
        return document.getElementById(item.id);
      });
    } else if (utilityMain && window.location.pathname === "/cart") {
      /* Review 2026-07-13: the basket page carries the rail like every other page */
      items = [
        { id: "main-cart-items", label: "Basket", icon: icons.grid },
        { id: "main-cart-footer", label: "Estimated total", icon: icons.tag }
      ].filter(function (item) {
        return document.getElementById(item.id);
      });
    } else if (articleContent || utilityMain) {
      var headingScope = articleContent || utilityMain;
      var iconCycle = [icons.grid, icons.book, icons.truck, icons.star, icons.shield, icons.tag, icons.wrench];
      var utilityHeadings = Array.prototype.slice.call(headingScope.querySelectorAll("h2"));
      if (!utilityHeadings.length && utilityMain) {
        var utilityHeading = headingScope.querySelector("h1");
        if (utilityHeading) utilityHeadings = [utilityHeading];
      }
      items = utilityHeadings
        .filter(function (heading) { return heading.textContent.trim().length && heading.offsetParent; })
        .slice(0, 9)
        .map(function (heading, index) {
          if (!heading.id) heading.id = "section-" + (slugify(heading.textContent) || index);
          heading.style.scrollMarginTop = "calc(var(--header-height, 0px) + 24px)";
          return { id: heading.id, label: heading.textContent.trim(), icon: iconCycle[index % iconCycle.length] };
        });
    } else {
      items = buildDynamicSectionItems();
    }

    if (items.length > 0) {
      var sortItems = function (list) {
        return list.sort(function (a, b) {
          var first = document.getElementById(a.id);
          var second = document.getElementById(b.id);
          if (!first || !second) return 0;
          return first.compareDocumentPosition(second) & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : 1;
        });
      };
      var railMarkup = function (list) {
        return list.map(function (item) {
          var safeLabel = item.label.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;");
          return '<a href="#' + item.id + '">' + item.icon + "<span>" + safeLabel + "</span></a>";
        }).join("");
      };

      items = sortItems(items);

      var rail = document.createElement("nav");
      rail.className = "quick-rail";
      rail.setAttribute("aria-label", "On this page");
      rail.innerHTML = railMarkup(items);
      document.body.appendChild(rail);

      if (!productRoot && !articleContent && !utilityMain) {
        var refreshRail = function () {
          var refreshedItems = sortItems(buildDynamicSectionItems());
          var refreshedMarkup = railMarkup(refreshedItems);
          if (refreshedMarkup !== rail.innerHTML) rail.innerHTML = refreshedMarkup;
          rail.hidden = refreshedItems.length === 0;
        };
        var refreshFrame = 0;
        var scheduleRailRefresh = function () {
          if (refreshFrame) return;
          refreshFrame = requestAnimationFrame(function () {
            refreshFrame = 0;
            refreshRail();
          });
        };
        var railNodeSelector = "section, [data-ha-rail-section], h1, h2";
        var affectsRail = function (record) {
          var target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
          if (target && target.closest("h1, h2")) return true;
          if (record.type !== "childList") return false;
          return Array.prototype.some.call(record.addedNodes, isRailNode) ||
            Array.prototype.some.call(record.removedNodes, isRailNode);
        };
        function isRailNode(node) {
          return node.nodeType === 1 && (node.matches(railNodeSelector) || node.querySelector(railNodeSelector));
        }
        var railScope = document.querySelector("main");
        if (railScope && "MutationObserver" in window) {
          new MutationObserver(function (records) {
            if (records.some(affectsRail)) scheduleRailRefresh();
          }).observe(railScope, {
            childList: true,
            subtree: true,
            characterData: true
          });
        }
        document.addEventListener("shopify:section:load", scheduleRailRefresh);
        document.addEventListener("shopify:section:unload", scheduleRailRefresh);
      }
    }
  }

  var scenes = Array.prototype.slice.call(document.querySelectorAll(
    ".ha-supplier .topo-scene, .ha-product .topo-scene, .ha-collection.topo-scene, .ha-collection .topo-scene"
  ));
  if (!scenes.length) return;

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)");
  var coarse = window.matchMedia("(pointer: coarse)");
  if (reduced.matches || coarse.matches) return;

  var frame = 0;

  window.addEventListener("pointermove", function (event) {
    if (event.pointerType === "touch") return;

    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(function () {
      var geometry = scenes.map(function (scene) {
        return { scene: scene, rect: scene.getBoundingClientRect() };
      });
      geometry.forEach(function (entry) {
        var scene = entry.scene;
        var rect = entry.rect;
        var isVisible = rect.bottom > 0 && rect.top < window.innerHeight;
        var isInside = event.clientY >= rect.top && event.clientY <= rect.bottom && isVisible;

        if (!isInside) {
          scene.classList.remove("topo-scene--active");
          return;
        }

        var x = Math.min(1, Math.max(0, (event.clientX - rect.left) / rect.width));
        var y = Math.min(1, Math.max(0, (event.clientY - rect.top) / rect.height));

        scene.style.setProperty("--mx", (x * 100).toFixed(1) + "%");
        scene.style.setProperty("--my", (y * 100).toFixed(1) + "%");
        scene.classList.add("topo-scene--active");
      });
    });
  }, { passive: true });

  scenes.forEach(function (scene) {
    scene.addEventListener("pointerleave", function () {
      scene.classList.remove("topo-scene--active");
    }, { passive: true });
  });
  })();

  (function () {
    document.addEventListener("ha:cart-updated", function (event) {
      var count = event && event.detail && event.detail.itemCount;
      if (typeof count !== "number") return;
      var badges = document.querySelectorAll("[data-ha-basket-count]");
      for (var i = 0; i < badges.length; i++) {
        badges[i].textContent = count;
      }
    });
  })();
})();
